import {
  gql

} from "@apollo/client";

export const CREATE_RESTAURANT = gql`
  mutation MyMutation($address: String = "", $closingTime: String = "", $coverPhoto: String = "", $description: String = "", $email: String = "", $latitude: Float = 1.5, $longitude: Float = 1.5, $name: String = "", $openTime: String = "", $openingDays: [String] = "", $phone: String = "", $uuid: String = "") {
  createRestaurant(
    input: {description: $description, phone: $phone, email: $email, address: $address, latitude: $latitude, longitude: $longitude, openTime: $openTime, uuid: $uuid, openingDays: $openingDays, coverPhoto: $coverPhoto, closingTime: $closingTime, name: $name}
  ) {
    error
    message
    data {
      uuid
      updated_at
      status
      phone
      openingDays
      openTime
      name
      longitude
      latitude
      email
      description
      created_at
      coverPhoto
      closingTime
      address
      active
    }
  }
}
`;


export const UPDATE_ORDER = gql`
mutation($status: String! $uuid: String!) {
  updateOrder(status: $status, uuid: $uuid){
    message
    error
    data {
      orderNo
      status
      orderItems {
        title
        photos
        quantity
        price
      }
    }
  }
}`
  ;

export const CREATE_UPDATE_MENU = gql`
mutation CreateUpdateMenu($ingredients: [String] = "", $photos: [String] = "", $price: String = "", $restaurantUuid: String = "", $title: String = "", $uuid1: String = "", $description1: String = "") {
  createUpdateMenu(
    input: {description: $description1, price: $price, restaurantUuid: $restaurantUuid, ingredients: $ingredients, photos: $photos, title: $title, uuid: $uuid1}
  ) {
    message
    error
    data {
      uuid
      updated_at
      title
      quantity
      price
      id
      deleted
      photos
      description
    }
  }
}
`;

export const CREATE_USER = gql`
mutation CreateUser($uuid: String = "", $username: String = "", $userRole: String = "", $phone: String = "", $lastName: String = "", $firstName: String = "") {
  createUser(
    input: {firstName: $firstName, lastName: $lastName, userRole: $userRole, username: $username, uuid: $uuid, phoneNumber: $phone}
  ) {
    message
    error
    data {
      uuid
      username
      userType
      phone
      lastName
      firstName
    }
  }
}
`;